import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import { FiChevronRight, FiChevronDown } from "react-icons/fi";
import { Link } from "react-router-dom";
import sb from "../assets/services-banner.webp";
import fp from "../assets/financial-planning.webp";
import insurance from "../assets/insurance.webp";
import mf from "../assets/mutual-funds.webp";
import rp from "../assets/retirement-planning.webp";
import wm from "../assets/wealth-management.webp";
import ce from "../assets/childerns-education.webp";

const Services = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? "" : index);
  };

  const services = [
    {
      id: "financial-planning",
      title: "Comprehensive Financial Planning",
      image: fp,
      description:
        "Financial planning is the foundation of long-term financial success. We provide customized strategies tailored to both individuals and businesses. Our services cover areas such as personal financial planning, retirement planning, investment and asset management, risk management, and insurance planning. A well-structured financial plan ensures security, stability, and helps individuals achieve both short-term and long-term financial goals. It also aids in tax optimization, investment growth, and risk mitigation, ensuring a strong financial future.",
      subSections: [
        {
          title: "🔹 Personal Financial Planning",
          content:
            "We create customized financial roadmaps to help you achieve financial independence and security, covering budgeting, savings, retirement, and investment strategies.",
        },
        {
          title: "🔹 Retirement Planning",
          content:
            "Secure your future with structured retirement plans, IRAs, and pension planning, ensuring you enjoy financial freedom in your later years.",
        },
        {
          title: "🔹 Investment Planning",
          content:
            "We guide you through smart investment strategies, including stocks, bonds, mutual funds, and real estate, aligning with your risk tolerance and financial goals.",
        },
        {
          title: "🔹 Risk Management & Insurance Planning",
          content:
            "Safeguard your financial future with tailored insurance strategies, including life, health, and disability coverage, to mitigate unforeseen risks.",
        },
        {
          title: "🔹 Business Financial Planning",
          content:
            "We help businesses with financial forecasting, cash flow management, and growth strategies to optimize financial performance and ensure sustainability.",
        },
      ],
      benefits: [
        "Financial Security & Stability",
        "Goal-Oriented Approach",
        "Smart Investment Decisions",
        "Tax Optimization & Savings",
        "Retirement Readiness",
        "Debt Management & Reduction",
        "Protection Against Risks",
        "Business Growth & Sustainability",
        "Peace of Mind & Financial Confidence",
      ],

      needs: [
        {
          title: "Wealth Creation & Growth",
          content:
            "Financial planning helps in building and growing wealth through savings, investments, and asset management, ensuring long-term financial security.",
        },
        {
          title: "Retirement Planning",
          content:
            "A structured financial plan ensures a comfortable retirement by creating a steady income stream after your working years. It includes IRAs, pensions, and other retirement investments.",
        },
        {
          title: "Budgeting & Expense Management",
          content:
            "Effective financial planning helps in tracking income, managing expenses, and avoiding unnecessary spending, leading to better financial discipline.",
        },
        {
          title: "Emergency Fund Preparation",
          content:
            "Life is unpredictable, and financial planning ensures you have a solid emergency fund to cover unexpected expenses like medical emergencies, job loss, or urgent repairs.",
        },
        {
          title: "Debt Management & Business Financial Stability",
          content:
            "With proper financial planning, you can reduce debt burdens, manage loan repayments, and avoid high-interest liabilities.",
        },
        {
          title: "Tax Efficiency & Compliance",
          content:
            "Financial planning helps minimize tax liabilities by using tax-saving investments, deductions, and strategic financial decisions to optimize your income.",
        },
        {
          title: "Investment & Asset Allocation",
          content:
            "A well-structured financial plan ensures your investments are diversified and aligned with your risk tolerance and long-term financial goals.",
        },
        {
          title: "Risk Management & Insurance Coverage",
          content:
            "Protecting yourself and your family against uncertainties is a crucial need for financial planning. It includes life insurance, health insurance, disability coverage, and other risk management strategies.",
        },
      ],
    },
    {
      id: "wealth-management",
      title: "Wealth Management",
      image: wm,
      description:
        "Wealth management is a comprehensive financial service that combines investment advice, financial planning, tax strategies, estate planning, and risk management to help individuals, families, and businesses grow and protect their wealth. It is a holistic approach tailored to high-net-worth individuals and businesses looking for long-term financial stability and growth.\nAt HYVIRU, our wealth management services are designed to provide personalized strategies that align with your financial goals and risk tolerance.",
      benefits: [
        "Personalized Financial Strategies",
        "Professional Investment Management",
        "Risk Management & Asset Protection",
        "Tax Optimization & Efficiency",
        "Retirement Planning",
        "Estate & Legacy Planning",
        "Cash Flow & Debt Management",
        "Business Succession Planning",
        "Access to Exclusive Investment Opportunities",
        "Peace of Mind & Financial Freedom",
      ],
    },
    {
      id: "retirement-planning",
      title: "Retirement Planning",
      image: rp,
      description:
        "Retirement planning is the process of setting financial goals, saving, and investing wisely to ensure a comfortable and financially secure life after retirement. It involves assessing future financial needs, creating savings strategies, managing investments, and preparing for healthcare and lifestyle expenses.\nAt HYVIRU, we help individuals and businesses create customized retirement plans that align with their financial goals and ensure peace of mind in their golden years.",
      benefits: [
        "Financial Independence",
        "Maintaining Your Desired Lifestyle",
        "Protection Against Inflation & Rising Costs",
        "Reduced Reliance on Social Security & Family",
        "Handling Unexpected Health Expenses",
        "Avoiding Financial Stress Later in Life",
        "More Investment Options & Better Returns",
        "Tax Benefits & Savings",
        "Support for Your Loved Ones",
        "Flexibility to Retire on Your Own Terms",
      ],
      needs: [
        {
          title: "The Power of Compounding",
          content:
            "The earlier you start saving, the more time your investments have to grow exponentially due to compounding interest. Even small contributions today can result in a substantial retirement fund in the future.",
        },
        {
          title: "Achieve Financial Independence",
          content:
            "Retirement planning ensures you have enough savings and investments to support your lifestyle without depending on others in your later years.",
        },
        {
          title: "Rising Cost of Living & Inflation",
          content:
            "As years go by, inflation will increase the cost of essentials like housing, healthcare, and daily expenses. A strong retirement plan helps you keep up with these rising costs.",
        },
        {
          title: "Social Security & Pensions May Not Be Enough",
          content:
            "Government benefits and pension plans may not cover all your expenses. Having a personal retirement plan ensures you have additional savings to maintain your standard of living.",
        },
        {
          title: "Unexpected Health Expenses",
          content:
            "Medical costs tend to rise with age. Retirement planning ensures you have enough health coverage, insurance, and emergency funds to handle unexpected healthcare expenses.",
        },
        {
          title: "Avoid Financial Stress Later in Life",
          content:
            "Without a retirement plan, you may have to work longer than expected or face financial difficulties. Planning ahead gives you the freedom to retire comfortably on your own terms.",
        },
        {
          title: "More Investment Options & Better Returns",
          content:
            "Starting early allows you to invest in diverse financial instruments such as stocks, bonds, mutual funds, and real estate, maximizing your potential returns.",
        },
        {
          title: "Tax Benefits & Savings",
          content:
            "Many retirement plans come with tax advantages, allowing you to save more while reducing tax liabilities. Strategies like IRAs, and pension contributions can lower your taxable income.",
        },
        {
          title: "Support for Your Loved Ones",
          content:
            "A well-structured retirement plan ensures financial security for your family and allows you to leave behind a legacy for your children or beneficiaries.",
        },
        {
          title: "Flexibility to Retire on Your Own Terms",
          content:
            "With proper planning, you can choose when and how you want to retire, whether that means early retirement, part-time work, or traveling the world.",
        },
      ],
    },
    {
      id: "mutual-funds",
      title: "Mutual Funds",
      image: mf,
      description:
        "A mutual fund is a type of investment vehicle that pools money from multiple investors to invest in a diversified portfolio of stocks, bonds, money market instruments, or other assets. These funds are managed by professional fund managers who make investment decisions on behalf of the investors to maximize returns while managing risk.\nMutual funds offer an accessible and efficient way for investors to grow their wealth without needing extensive market knowledge.",
      subSections: [
        {
          title: "🔹 Equity Mutual Funds",
          content:
            "Invest primarily in stocks and are ideal for long-term capital growth.",
        },
        {
          title: "🔹 Debt Mutual Funds",
          content:
            "Invest in bonds and fixed-income securities, offering stability and lower risk.",
        },
        {
          title: "🔹 Hybrid/Balanced Funds",
          content:
            "A mix of equity and debt investments, balancing risk and reward.",
        },
        {
          title: "🔹 Index Funds",
          content:
            "Track a specific market index and offer passive investment strategies.",
        },
        {
          title: "🔹 Money Market Funds",
          content:
            "Invest in short-term, low-risk securities, offering liquidity and safety.",
        },
      ],
      benefits: [
        "Diversification",
        "Professional Management",
        "Liquidity",
        "Affordability",
        "Tax Benefits",
        "Potential for High Returns",
      ],
    },
    {
      id: "insurance",
      title: "Insurance",
      image: insurance,
      description:
        "Insurance is a financial arrangement where an individual or business pays regular premiums to an insurance company in exchange for financial protection against unexpected losses. It helps manage risks by covering expenses related to accidents, illnesses, property damage, or even loss of life.\nOur customized insurance strategies are designed to provide financial stability in times of uncertainty.",
      subSections: [
        {
          title: "🔹 Life Insurance",
          content:
            "Life insurance provides financial security to the policyholder’s family in case of death or disability.\n🔹 Term Life Insurance – Offers coverage for a fixed period and pays benefits only if the insured person passes away within the term.\n🔹 Whole Life Insurance – Provides lifelong coverage and a guaranteed payout to beneficiaries.\n🔹 Endowment Plans – Combines life insurance with savings, paying a lump sum after a specific period or upon death.\n🔹 Unit-Linked Insurance Plans (ULIPs) – A combination of investment and life insurance, where premiums are partly invested in market-linked funds.\n🔹 Money-Back Policy – Periodic payouts at regular intervals during the policy term, plus a lump sum at maturity.\n🔹 Pension/Retirement Plans – Provides financial security after retirement through annuity payments.",
        },
        {
          title: "🔹 General Insurance (Non-Life Insurance)",
          content:
            "General insurance covers assets, health, businesses, and liabilities against financial risks.\n🔹 Health Insurance – Covers medical expenses for illnesses, hospitalizations, and surgeries.\n🔹 Motor Insurance – Protects vehicles against damage, theft, or accidents (includes Third-Party and Comprehensive policies).\n🔹 Home Insurance – Covers damages to homes due to fire, natural disasters, or theft.\n🔹 Travel Insurance – Provides financial protection against medical emergencies, trip cancellations, lost luggage, and travel risks.\n🔹 Business Insurance – Protects businesses from financial losses due to property damage, liability claims, or operational risks.\n🔹 Liability Insurance – Covers legal and financial liabilities, including professional indemnity and public liability.\n🔹 Marine Insurance – Protects cargo and ships against loss or damage during transportation.\n🔹 Crop Insurance – Covers farmers against losses due to natural disasters affecting their crops.",
        },
      ],
      benefits: [
        "Financial Security",
        "Risk Management",
        "Peace of Mind",
        "Legal Compliance",
        "Investment & Savings Benefits",
      ],
    },
    {
      id: "childern education",
      title: "Children Education",
      image: ce,
      description:
        "Providing financial security for a child's education and marriage is a priority for many parents. Our education and marriage planning services include structured investment strategies, education savings plans, and financial strategies for securing marriage expenses. Early financial planning helps reduce future financial burdens, ensures uninterrupted education, and provides structured investment growth with tax benefits. By preparing in advance, parents can secure their child's future without financial stress.",
    },
  ];

  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="relative w-full h-[250px] md:h-[480px]">
        <img
          src={sb}
          alt="Business Consulting"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="bg-primary flex items-center justify-center p-4">
        <h2 className="text-white text-2xl font-semibold">Our Services</h2>
      </div>

      {/* Services Section */}
      <div className="p-8 max-w-7xl mx-auto space-y-16">
        {services?.map((service) => (
          <div
            key={service.id}
            id={service.id}
            className="bg-white rounded-lg shadow-lg p-8"
          >
            {/* Service Title */}
            <h3 className="text-3xl font-bold text-primary mb-6">
              {service.title}
            </h3>

            {/* Service Description with image*/}
            <div className="flex flex-col lg:flex-row items-center gap-8 mb-8">
              {/* Image Section */}
              <div className="w-full lg:w-1/2">
                <img
                  src={service.image}
                  alt={service.title}
                  loading="lazy"
                  className="w-full h-[260px] md:h-[400px] rounded-lg shadow-2xl"
                />
              </div>

              {/* Description Section */}
              <div className="w-full lg:w-1/2">
                <p className="text-lg text-gray-700 text-justify">
                  {service.description}
                </p>
              </div>
            </div>

            {/* Sub-Sections (if any) */}
            {service.subSections && (
              <div className="space-y-4">
                {service.subSections?.map((sub, index) => {
                  const faqId = `${service.id}-${index}`;
                  return (
                    <div key={faqId}>
                      {/* Toggle Header */}
                      <div
                        className={`flex items-center justify-between cursor-pointer p-4 rounded-lg border shadow-md bg-gray-50 ${
                          activeIndex === faqId
                            ? "bg-primary text-white"
                            : "hover:bg-primary hover:text-white transition"
                        }`}
                        onClick={() => toggleFAQ(faqId)}
                      >
                        <span>
                          {activeIndex === faqId ? <FaMinus /> : <FaPlus />}
                        </span>
                        <p className="flex-1 text-lg font-semibold">
                          {sub.title}
                        </p>
                        {activeIndex === faqId ? (
                          <FiChevronDown />
                        ) : (
                          <FiChevronRight />
                        )}
                      </div>

                      {/* Expanded Content */}
                      {activeIndex === faqId && (
                        <p className="text-gray-700 mt-2 leading-relaxed text-justify">
                          {sub.content?.split("\n").map((line, i) => (
                            <span key={i}>
                              {line}
                              <br />
                            </span>
                          ))}
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            {/* Key Benefits */}
            {service.benefits?.length > 0 && (
              <div className="mt-8">
                <h4 className="text-2xl font-semibold mb-4 text-primary">
                  Key Benefits
                </h4>
                <ul className="list-disc ml-6 space-y-2 text-gray-700">
                  {service.benefits?.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </ul>
              </div>
            )}

            {/* Needs of Financial planning */}
            {service.needs?.length > 0 && (
              <div className="mt-8">
                <h4 className="text-2xl font-semibold mb-4 text-primary">
                  Needs of {service.title}
                </h4>
                <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
                  {service.needs &&
                    service.needs?.map((need, index) => (
                      <li
                        key={index}
                        className="relative group bg-gray-200 p-4 rounded-lg hover:bg-primary hover:text-white transition"
                      >
                        <span>{need.title}</span>
                        <div className="absolute hidden group-hover:block bg-white text-black p-4 rounded-lg shadow-lg mt-2 w-72 z-50 text-justify">
                          {need.content}
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            )}

            {/* Call to Action - Updated to use Link component */}
            <div className="mt-8 text-center">
              <Link
                to="/contact-us"
                className="bg-primary text-white px-6 py-3 rounded-lg hover:bg-[#1e1b5a] transition inline-block"
              >
                Start Your Journey
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
